import { z } from 'zod'

export const membershipTierSchema = z.enum(['REGULAR', 'GOLD'])

export type MembershipTier = z.infer<typeof membershipTierSchema>

/**
 * Tier is derived from the lifetime top-up total in `balance_ledger`, which
 * includes a `migration_opening` entry for every user carried over from V1 —
 * so existing GOLD members keep their tier without migrating old invoices.
 */
export const membershipSchema = z.object({
  tier: membershipTierSchema,
  lifetimeTopupUsd: z.number(),
  thresholdUsd: z.number(),
  remainingUsd: z.number(),
  groupUrl: z.string().nullable(),
})

export type Membership = z.infer<typeof membershipSchema>
